module.exports = __webpack_public_path__ + "static/media/salao_jardim_2.9638a4ee.jpg";